"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_select_1 = require("react-select");
const sliceReview_1 = require("../../../slice/sliceReview");
const store_1 = require("../../../store");
const ReviewStage_1 = __importDefault(require("./ReviewStage"));
const notification_1 = __importDefault(require("../../../../reviews/constants/notification"));
const helper_1 = require("../../../../reviews/helper");
const selectors_1 = __importDefault(require("../../../slice/selectors"));
const constants_1 = require("../../../slice/sliceReview/constants");
const sliceTemplate_1 = require("../../../slice/sliceTemplate");
const constants_2 = require("../../../slice/sliceTemplate/constants");
const ApplyTemplateModal_1 = __importDefault(require("./ApplyTemplateModal"));
const DeleteStageModal_1 = require("./DeleteStageModal");
const OptionSelectTemplate_1 = __importDefault(require("./OptionSelectTemplate"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const DeleteStageModal = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('./DeleteStageModal'))));
const TriggerStateModal = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('../../../../reviews/components/TriggerStateModal'))));
const DATA_STRUCTURE = {
    dataKey: 'data',
    isJsonApi: true,
    label: 'label',
    lastPage: 'meta.page.last_page',
    pageSize: 5,
    type: 'roundTypes',
    value: 'id',
};
const DEFAULT_URL = `/v2/api/round-types?filter[is_active]=1`;
const DEFAULT_URL_WORKFLOW_TEMPLATES = `/v2/api/workflow-templates`;
const DATA_STRUCTURE_WORKFLOW_TEMPLATES = {
    dataKey: 'data',
    isJsonApi: true,
    label: 'label',
    lastPage: 'meta.page.last_page',
    pageSize: 25,
    type: 'workflowTemplates',
    value: 'id',
    searchKey: 'name',
};
const OverviewReviewSetting = ({ formikProps, }) => {
    const { errors, setErrors, setFieldValue } = formikProps;
    const scrollRef = (0, react_1.useRef)(null);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const { roundStages, round, instruction, defaultStatusCalculation, defaultNotification, mode, titleReview, project, selectedTemplate, openApplyTemplateModal, } = (0, react_redux_1.useSelector)(selectors_1.default);
    const [openRemoveStageModal, setOpenRemoveStageModal] = (0, react_1.useState)(DeleteStageModal_1.initialDeleteModal);
    const [triggerStateModal, setTriggerStateModal] = (0, react_1.useState)({
        index: 0,
        isOpen: false,
    });
    const handleOpenDeleteStageModal = (stageRemoveModal) => {
        setOpenRemoveStageModal(stageRemoveModal);
    };
    const handleSaveTemplateClick = () => {
        // we make sure that the stage must to have members
        // this block will validate member stage
        const stageErrors = [];
        let errorFlag = roundStages.some((stage) => { var _a; return !((_a = stage.members) === null || _a === void 0 ? void 0 : _a.length); });
        if (errorFlag) {
            // this block will add a error to errors of formik
            roundStages.forEach((stage) => {
                var _a;
                const haveMembers = (_a = stage.members) === null || _a === void 0 ? void 0 : _a.length;
                stageErrors.push(!haveMembers
                    ? { reviewers: 'Must have at least 1 member' }
                    : undefined);
            });
            setErrors({ stages: stageErrors });
            utilities_1.default.notification.danger(notification_1.default.requireReviewer);
            return;
        }
        // this is unique name stage
        if ((0, helper_1.uniqueNameStages)(roundStages)) {
            errorFlag = true;
            utilities_1.default.notification.danger(notification_1.default.uniqueStageName);
        }
        if (!errorFlag) {
            dispatch((0, sliceTemplate_1.closeTemplate)());
            dispatch((0, sliceReview_1.nextModal)());
        }
    };
    const handleChangeReviewType = (type) => {
        dispatch((0, sliceReview_1.updateCurrentRound)({
            valueUpdate: {
                roundType: type,
            },
        }));
    };
    const executeScroll = () => {
        var _a;
        if (scrollRef) {
            (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };
    const handleAddStage = async () => {
        await dispatch((0, sliceReview_1.addRoundStages)());
        executeScroll();
    };
    (0, react_1.useEffect)(() => {
        // when we create a new review, stageStatusStrategy of roundStage is null
        // we have to set default values for roundStage
        // this variable to avoid set default value if we back to reviewing phase
        if ((mode === constants_1.MODE.share || mode === constants_1.MODE.create) &&
            (0, helper_1.isDefaultStage)(roundStages))
            dispatch((0, sliceReview_1.updateNotifyRoundStageDefault)());
    }, [defaultStatusCalculation, defaultNotification]);
    const debounceChange = (0, debounce_1.default)((changeFn) => changeFn(), 50);
    const handleChangeTitleReview = (newTitle) => {
        dispatch((0, sliceReview_1.updateReviewTitle)(newTitle));
    };
    const handleChangeInstructions = (newInstructions) => {
        debounceChange(() => dispatch((0, sliceReview_1.updateInstructions)(newInstructions)));
        setFieldValue('instruction', newInstructions);
    };
    const handleChangeTemplateSelect = (template) => {
        dispatch((0, sliceTemplate_1.setSelectedTemplate)(template));
        dispatch((0, sliceTemplate_1.setOpenTemplateModal)(true));
    };
    const handleEditTemplate = (template) => {
        dispatch((0, sliceTemplate_1.setSelectedTemplate)(template));
        dispatch((0, sliceReview_1.openTemplateModal)(constants_2.SAVING_METHOD.saveAsNew));
        dispatch((0, sliceReview_1.enableNextBtn)());
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_modules_less_1.default['overview-root'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['overview-root__form'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['inputs-row'] },
                    react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['inputs-row__input'], styles_modules_less_1.default['inputs-row__input--title']) },
                        react_1.default.createElement("div", { className: styles_modules_less_1.default['row-label__section'] },
                            react_1.default.createElement("span", { className: styles_modules_less_1.default['row-label__text'] }, "Review title"),
                            react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                                    className: 'overview-root__tooltip',
                                    content: 'The Review Title defaults to the first Asset or URL in your Review Round and can be updated at any time during the review.',
                                    popperOptions: {
                                        strategy: 'fixed',
                                    },
                                    placement: 'top',
                                    trigger: 'click',
                                } },
                                react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['row-label__icon'], 'fal fa-info-circle') }))),
                        react_1.default.createElement(pulse_components_1.PulseInput, { InputBaseProps: {
                                name: 'title',
                                value: titleReview,
                                placeholder: 'Quick Search templates',
                                onChange: (e) => handleChangeTitleReview(e.target.value),
                            }, isInvalid: !!errors.title, error: errors.title, required: !!errors.title })),
                    react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['inputs-row__input'], styles_modules_less_1.default['inputs-row__input--type']) },
                        react_1.default.createElement("div", { className: styles_modules_less_1.default['row-label__section'] },
                            react_1.default.createElement("span", { className: styles_modules_less_1.default['row-label__text'] }, "Round Type"),
                            react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                                    className: 'overview-root__tooltip',
                                    content: 'Each Round of your Review can be classified by Round Type.',
                                    popperOptions: {
                                        strategy: 'fixed',
                                    },
                                    placement: 'top',
                                    trigger: 'click',
                                } },
                                react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['row-label__icon'], 'fal fa-info-circle') }))),
                        react_1.default.createElement(pulse_components_1.PulseSelectBase, { name: "roundType", hideSelectedOptions: true, selectOnlyOption: true, value: round === null || round === void 0 ? void 0 : round.roundType, dataStructure: DATA_STRUCTURE, url: DEFAULT_URL, isDisabled: false, isClearable: false, classes: {
                                selectContainer: styles_modules_less_1.default['row-label__selectContainer'],
                                menu: {
                                    menuCtn: styles_modules_less_1.default['round-type__menu-container'],
                                },
                            }, hideMenuOnValueChange: true, onChange: handleChangeReviewType, isSearchable: false, isInvalid: !!errors.round_type_id }))),
                react_1.default.createElement("div", { className: styles_modules_less_1.default['inputs-row'] },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['inputs-row__input'] },
                        react_1.default.createElement("div", { className: styles_modules_less_1.default['row-label__section'] },
                            react_1.default.createElement("span", { className: styles_modules_less_1.default['row-label__text'] }, "Round instructions"),
                            react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                                    className: 'overview-root__tooltip',
                                    content: 'Provide instructions for the reviewers of this document. ',
                                    popperOptions: {
                                        strategy: 'fixed',
                                    },
                                    placement: 'top',
                                    trigger: 'click',
                                } },
                                react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['row-label__icon'], 'fal fa-info-circle') }))),
                        react_1.default.createElement("textarea", { className: (0, clsx_1.default)(styles_modules_less_1.default['inputs-row__input--instruction'], formikProps.errors.instruction &&
                                styles_modules_less_1.default['inputs-row__input--instruction--error']), placeholder: "Please enter instructions for the review of this document here \u2026", onInput: (e) => handleChangeInstructions(e.target.value), defaultValue: instruction, maxLength: 2001 })))),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['overview-root__stages'] },
                react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-row'], 'stage-row') },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['inputs-row__input'] },
                        react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['row-label__section'], styles_modules_less_1.default['row-label__stage']) },
                            react_1.default.createElement("div", { className: styles_modules_less_1.default['label-stage__item'] },
                                react_1.default.createElement("span", { className: styles_modules_less_1.default['row-label__text'] }, "Round stages"),
                                react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                                        className: 'overview-root__tooltip',
                                        content: 'You can rename the stage, adjust its settings and add more stages to this Round.',
                                        popperOptions: {
                                            strategy: 'fixed',
                                        },
                                        placement: 'top',
                                        trigger: 'click',
                                    } },
                                    react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['row-label__icon'], 'fal fa-info-circle') }))),
                            react_1.default.createElement("div", { className: styles_modules_less_1.default['label-stage__item'] },
                                helper_1.CREATE_TEMPLATE_PERMISSION === 'y' && (react_1.default.createElement("div", { onClick: () => handleSaveTemplateClick(), className: (0, clsx_1.default)(styles_modules_less_1.default['stage-item__section'], styles_modules_less_1.default['review-template']) },
                                    react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-save', styles_modules_less_1.default['stage-item__section--icon']) }),
                                    react_1.default.createElement("span", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-item__text'], styles_modules_less_1.default['stage-item__text--review-template']) }, "Save As Template"))),
                                react_1.default.createElement("div", { className: styles_modules_less_1.default['label-stage__item'] },
                                    helper_1.CREATE_TEMPLATE_PERMISSION === 'y' && (react_1.default.createElement(pulse_components_1.PulseSelectBase, { changeHandler: (value, action) => {
                                            if ((action === null || action === void 0 ? void 0 : action.name) === 'edit') {
                                                handleEditTemplate(value);
                                                return;
                                            }
                                            handleChangeTemplateSelect(value);
                                        }, url: `${DEFAULT_URL_WORKFLOW_TEMPLATES}?filter[job_id]=${project === null || project === void 0 ? void 0 : project.value}`, TippyProps: {
                                            offset: [0, 10],
                                            placement: 'bottom-end',
                                            popperOptions: {
                                                strategy: 'fixed',
                                            },
                                        }, components: {
                                            Control: (controlProps) => (react_1.default.createElement("div", { className: styles_modules_less_1.default['available-templates-select__control'] },
                                                react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['available-templates-select__searchIcon'], 'fal fa-search') }),
                                                react_1.default.createElement(react_select_1.components.Control, { className: styles_modules_less_1.default['available-templates-select__search'], ...controlProps }))),
                                            Placeholder: (placeholderProps) => (react_1.default.createElement(react_select_1.components.Placeholder, { className: styles_modules_less_1.default['available-templates-select__placeholder'], ...placeholderProps })),
                                            Menu: (menuProps) => (react_1.default.createElement(react_select_1.components.Menu, { className: styles_modules_less_1.default['available-templates-select__menu'], ...menuProps })),
                                            Option: (optionProps) => (react_1.default.createElement(OptionSelectTemplate_1.default, { ...optionProps })),
                                        }, classes: {
                                            selectContainer: styles_modules_less_1.default['available-templates__root'],
                                            menu: {
                                                menuCtn: styles_modules_less_1.default['available-templates__menuCtn'],
                                            },
                                        }, closeMenuOnSelect: true, menuShouldScrollIntoView: true, isMulti: false, isSearchable: true, isClearable: false, hideMenuOnValueChange: true, insideModal: true, dataStructure: DATA_STRUCTURE_WORKFLOW_TEMPLATES, placeholder: "Quick Search templates", customContainer: react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-item__section'], styles_modules_less_1.default['review-template'], styles_modules_less_1.default['add-stage']) },
                                            react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-list-alt', styles_modules_less_1.default['stage-item__section--icon']) }),
                                            react_1.default.createElement("span", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-item__text'], styles_modules_less_1.default['stage-item__text--review-template']) }, "Choose Template")) })),
                                    react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-item__section'], styles_modules_less_1.default['add-stage']), onClick: handleAddStage },
                                        react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-plus', styles_modules_less_1.default['stage-item__section--icon']) }),
                                        react_1.default.createElement("span", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-item__text'], styles_modules_less_1.default['stage-item__text--add-stage']) }, "Add Stage"))))),
                        roundStages.map((stage, index) => {
                            return (react_1.default.createElement(ReviewStage_1.default, { key: index, stage: stage, indexStage: index, setOpenRemoveStageModal: handleOpenDeleteStageModal, formikProps: formikProps, setTriggerStateModal: setTriggerStateModal }));
                        }),
                        react_1.default.createElement("div", { id: "last-stage-scroll", ref: scrollRef }))))),
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") },
            react_1.default.createElement(DeleteStageModal, { open: openRemoveStageModal.open, index: openRemoveStageModal.index, stageName: openRemoveStageModal.stageName, setOpenRemoveStageModal: handleOpenDeleteStageModal }),
            react_1.default.createElement(ApplyTemplateModal_1.default, { executeScroll: executeScroll, open: openApplyTemplateModal }),
            react_1.default.createElement(TriggerStateModal, { triggerStateModal: triggerStateModal, setTriggerStateModal: setTriggerStateModal, formikProps: formikProps }))));
};
exports.default = react_1.default.memo(OverviewReviewSetting);
